export default __webpack_public_path__ + "static/media/js-2d-pathing-icon.28a9a4e8.png";